import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button} from 'views/components';
import {Edit as EditIcon, Logout as LogoutIcon} from 'views/icons';
import {Translate, translate, Map} from 'views/module';

import BuildCareview from './BuildCareview';
import TimelineCard from './TimelineCard';

import moment from 'moment';

const ShiftClockedOut = (props) => {
  const {clockOut, caregiverData, answers, setModel} = props;

  const timeString = moment(clockOut.createdAt).format('LLL');

  const actualClockoutTimeFormatted = clockOut.data.actualClockoutTimeFormatted;
  const suggestedClockoutTimeFormatted = clockOut.data.suggestedClockoutTimeFormatted;

  // Format data if present
  const actualClockoutTime = actualClockoutTimeFormatted ? moment(actualClockoutTimeFormatted).format('h:mm A') : null;
  const suggestedClockoutTime = suggestedClockoutTimeFormatted ? moment(suggestedClockoutTimeFormatted).format('h:mm A') : null;
  const location = clockOut.data.location;
  const notes = clockOut.data.additionalNotes || translate('schedule.eventDetail.EventTimelineSection.ShiftClockedOut.NoNotes');

  const onClickEditClockOut = () => {
    setModel('UPDATE_CAREGIVER_CLOCK_OUT');
  };

  return (
    <TimelineCard
      timeString={timeString}
      icon={LogoutIcon}
      iconColor="#1e8e3e"
      timeBg="#e0e0e0"
      title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.Title' />}
    >
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          <Translate
            expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.Description'
            substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
          />
        </Typography>

        {
          actualClockoutTimeFormatted && suggestedClockoutTimeFormatted &&
          (
            <Stack spacing={1}>
              {/* Clock out timings */}
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={1}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'} whiteSpace="nowrap">
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.ClockoutTime'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'} whiteSpace="nowrap">
                  {actualClockoutTime}
                </Typography>
              </Stack>
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={1}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'} whiteSpace="nowrap">
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.EditedClockoutTime'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'} whiteSpace="nowrap">
                  {suggestedClockoutTime}
                </Typography>
                <Button
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => onClickEditClockOut()}
                  sx={{
                    'color': 'black',
                    'backgroundColor': '#ffffff',
                    'border': '1px solid #e0e0e0',
                    'borderRadius': 2,
                    'textTransform': 'none',
                    'fontSize': '12px',
                    'fontWeight': 'normal',
                    '& .MuiButton-startIcon': {
                      marginRight: '4px',
                    },
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                      borderColor: '#d0d0d0',
                    },
                  }}
                >
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.EditClockoutButton' />
                </Button>
              </Stack>

              {/* Notes */}
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={1}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'}>
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.Notes'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'}>{notes}</Typography>
              </Stack>

              {/* Location Data */}
              <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'}>
                <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.Location'/>
              </Typography>
              {
                location ?
                  <Map height={'200px'} width={'100%'} style={{maxWidth: '100%'}} coordinates={[location.latitude, location.longitude]} /> :
                  <Typography color="text.secondary" fontSize={'14px'}>
                    <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.NoLocation'/>
                  </Typography>
              }

              {/* Careview Summary */}
              <Stack spacing={1} mt={2}>
                <Typography fontWeight={700} textAlign={'left'} fontSize={'18px'}>
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedOut.CareviewSummary'/>
                </Typography>
                <BuildCareview answers={answers} />
              </Stack>
            </Stack>
          )
        }
      </Stack>

    </TimelineCard>
  );
};

ShiftClockedOut.propTypes = {
  clockOut: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.shape({
      actualClockoutTimeFormatted: PropTypes.string,
      suggestedClockoutTimeFormatted: PropTypes.string,
      location: PropTypes.object,
      additionalNotes: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  answers: PropTypes.object,
  setModel: PropTypes.func.isRequired,
};

export default ShiftClockedOut;
